module.exports = __webpack_public_path__ + "static/media/velour2C.b46ae2ab.jpg";